import React from "react";
import { Col, Row, Tag } from "antd";
import RatingsWidget from "./RatingsWidget";
import { FaCircleCheck } from "react-icons/fa6";
import { IoAlertCircleSharp } from "react-icons/io5";
import WidgetCard from "./WidgetCard";
import { IDeepDiveModalConfig } from "@ts/common-types";

interface IRatingsAndReviewsWidget {
    title?: string;
    widgetData: IDeepDiveModalConfig;
}

const RatingsAndReviewsWidget: React.FC<IRatingsAndReviewsWidget> = ({ title, widgetData }) => {
    return (
        <Row className="my-4" gutter={16}>
            <Col span={10} className="Ratings">
                <RatingsWidget widgetData={widgetData.reviews} />
            </Col>
            <Col span={14} className="Reviews">
                <WidgetCard className="h-100">
                    <Row>
                        <Col span={14}>
                            <h5>
                                Customers Say{" "}
                                <span
                                    className="text-muted"
                                    style={{
                                        fontSize: "14px",
                                    }}
                                >
                                    (Last 90 Days)
                                </span>
                            </h5>
                        </Col>
                        <Col span={5} offset={5} className="d-none">
                            <p className="text-primary text-end">
                                view all reviews
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <p>{widgetData?.reviews?.summary || "-"}</p>
                    </Row>
                    <Row>
                        {widgetData.reviews?.themes &&
                            Object.keys(widgetData.reviews?.themes).map(
                                (item, key) => (
                                    <Tag
                                        key={key}
                                        icon={
                                            +widgetData.reviews?.themes[item] >
                                            3 ? (
                                                <FaCircleCheck
                                                    style={{
                                                        color: "green",
                                                        fontSize: "14px",
                                                    }}
                                                    className="me-2 mb-1"
                                                />
                                            ) : (
                                                <IoAlertCircleSharp
                                                    style={{
                                                        color: `${
                                                            +widgetData.reviews
                                                                ?.themes[item] >
                                                            3
                                                                ? "green"
                                                                : +widgetData
                                                                      .reviews
                                                                      ?.themes[
                                                                      item
                                                                  ] === 3
                                                                ? "#FABC3F"
                                                                : "#C7253E"
                                                        }`,
                                                        fontSize: "16px",
                                                    }}
                                                    className="me-2 mb-1"
                                                />
                                            )
                                        }
                                        className="px-2 py-1 my-1"
                                    >
                                        <p
                                            className="d-inline"
                                            style={{
                                                fontSize: "14px",
                                            }}
                                        >
                                            {item}
                                        </p>
                                    </Tag>
                                )
                            )}
                    </Row>
                    <Row className="my-3 flex-column">
                        <h5>
                            Top{" "}
                            <span
                                style={{
                                    color: "green",
                                }}
                            >
                                +ve
                            </span>
                        </h5>
                        <p
                            style={{
                                color: "green",
                                fontStyle: "italic",
                            }}
                        >
                            {widgetData.reviews?.top_pos || "-"}
                        </p>
                    </Row>
                    <Row className="flex-column">
                        <h5>
                            Top{" "}
                            <span
                                style={{
                                    color: "red",
                                }}
                            >
                                -ve
                            </span>
                        </h5>
                        <p
                            style={{
                                color: "red",
                                fontStyle: "italic",
                            }}
                            className="d-block"
                        >
                            {widgetData.reviews?.top_neg || "-"}
                        </p>
                    </Row>
                </WidgetCard>
            </Col>
        </Row>
    );
};

export default RatingsAndReviewsWidget;
